import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/PenFill.tsx
const PenFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M17.707 2.293a1 1 0 0 0-1.414 0L14 4.586 19.414 10l2.293-2.293a1 1 0 0 0 0-1.414l-4-4ZM18 11.414 12.586 6l-9.293 9.293A1 1 0 0 0 3 16v4a1 1 0 0 0 1 1h4a1 1 0 0 0 .707-.293L18 11.414Z",
		fill: props.fill || "currentColor"
	})
}));
export { PenFillIcon };
